export const handleNameLinkSort = (a, b) => {
  const { title: nameA } = a.props;
  const { title: nameB } = b.props;
  if (nameA === nameB) {
    return 0;
  }
  return nameA < nameB ? -1 : 1;
};

export const handleProgressSort = (a, b) => {
  const { answered: answeredA } = a.props;
  const { answered: answeredB } = b.props;
  if (answeredA === answeredB) {
    return 0;
  }
  return answeredA < answeredB ? -1 : 1;
};

export const handleDueSort = (a, b) => {
  const { 'data-duedate': dueDateA } = a.props;
  const { 'data-duedate': dueDateB } = b.props;
  if (dueDateA === dueDateB) {
    return 0;
  }
  return dueDateA < dueDateB ? -1 : 1;
};
